import { useQuery } from '@tanstack/react-query'
import { portraitsService } from '@/api/services/portraits.service'
import { queryKeys } from '@/api/query-keys'

/** One portrait's details, refetched on every select like `useCandidDetail` so its page list is
 *  as fresh as Core's indexing. Pass `null` to skip the request. */
export function usePortraitDetail(portraitId: string | null) {
  return useQuery({
    queryKey: queryKeys.portraits.detail(portraitId),
    queryFn: () => portraitsService.getPortraitDetail(portraitId!),
    enabled: !!portraitId,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
